import React, { useState } from 'react';
import { Button, Card, Col, Container, Form, Image, Row } from 'react-bootstrap';
import PageSubTitle from '../Components/Layout/PageSubTitle';
import ContactUsData from '../data/contact-data.json';
import { motion } from 'framer-motion';

import DatePicker from 'react-date-picker';
import TimePicker from 'react-time-picker';
import SectionTitle from '../Components/ui/SectionTitle';

export default function ContactUs() {
  const [ContactData] = useState(ContactUsData);
  const [date, setDate] = useState(new Date());
  const [time, setTime] = useState('10:00');
  return (
    <>
      <PageSubTitle pagename="Contact Us" />
      <motion.section initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}} viewport={{once: true}} className='section'>
        <Container>
          <Row>
            {ContactData.ContactInfo.map((data, i) => (
              <Col sm={6} xl={3} className='text-center' key={`info-${i}`}>
                <motion.i initial={{opacity: 0,}} whileInView={{opacity: 1}} transition={{duration: 0.5}} className={`${data.icon} display-4 text-danger`}></motion.i>
                <motion.h4 initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='my-2'>{data.title}</motion.h4>
                {data.details.map((infodetail, idx) => (
                  <motion.p initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className={`text-muted ${idx === 0 ? 'mb-1' : ''}`} key={idx}>{infodetail}</motion.p>
                ))}
              </Col>
            ))}
          </Row>
          <Row>
            <Col md={12}>
              <hr className='border-soft-dark my-5' />
            </Col>
          </Row>
          <Row className='pt-4'>
            {ContactData.BranchesData.map((branch, a) => (
              <Col md={4} key={`branch-${a}`}>
                <Image src={branch.branchimg} alt="" className='img-fluid img-shadow rounded' />
                <Card className='card-blur mt-n4 mx-3'>
                  <Card.Body>
                    <motion.div initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='section-title text-center mb-4'>
                      <h4 className='text-center fs-24'>{branch.title}</h4>
                      <span className='title-icon'><i className="ri-restaurant-2-fill  text-danger opacity-50"></i></span>
                    </motion.div>
                    {branch.details.map((branchdetail, index) => (
                      <motion.div initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className="d-flex align-items-center mt-3" key={branchdetail.id || index}>
                        <div className="flex-shrink-0">
                          <div className='avatar avatar-sm bg-soft-danger text-danger rounded-circle'>
                            <i className={`${branchdetail.icon} fs-20`}></i>
                          </div>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <p className='text-muted text-break fs-18 mb-0'>{branchdetail.content}</p>
                        </div>
                      </motion.div>
                    ))}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </motion.section>

      <motion.section initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}} viewport={{once: true}} className='section pt-0'>
        <Container>
          <Row>
            <Col md={12}>
              <div className='contact-form rounded-3'>
                <div className='dark-overlay rounded-3'></div>
                <Row className='justify-content-center position-relative z-2'>
                  <Col md={6} className='section-title text-center mb-4 pb-3'>
                    <SectionTitle title="Book A Table" className="text-white" titleIconWhite={true}/>
                  </Col>
                </Row>

                <Form className='position-relative z-2'>
                  <Row>
                    <Col lg={4}>
                      <motion.div initial={{opacity: 0,y:20}} whileInView={{opacity: 1,y:0}} transition={{duration: 0.5}} className='mb-3 ctm-form'>
                        <Form.Label className='text-white'>How Many People</Form.Label>
                        <Form.Select size='lg'>
                          <option>Select People</option>
                          <option value="1">1 People</option>
                          <option value="2">2 People</option>
                          <option value="3">3 People</option>
                          <option value="4">4 People</option>
                          <option value="5">5 People</option>
                          <option value="6">6 People</option>
                          <option value="7">7 People</option>
                          <option value="8">8 People</option>
                          <option value="9">9 People</option>
                          <option value="10">10 People</option>
                        </Form.Select>
                      </motion.div>
                    </Col>
                    <Col md={6} lg={4}>
                      <motion.div initial={{opacity: 0,y:20}} whileInView={{opacity: 1,y:0}} transition={{duration: 0.5}} className='mb-3 date-time-picker dtp-lg'>
                        <Form.Label className='text-white'>Select Booking Date</Form.Label>
                        <DatePicker onChange={setDate} value={date} />
                      </motion.div>
                    </Col>
                    <Col md={6} lg={4}>
                      <motion.div initial={{opacity: 0,y:20}} whileInView={{opacity: 1,y:0}} transition={{duration: 0.5}} className='mb-3 date-time-picker dtp-lg'>
                        <Form.Label className='text-white'>Select Time</Form.Label>
                        <TimePicker onChange={setTime} value={time} />
                      </motion.div>
                    </Col>
                    <Col xs={12} className='text-center mt-4'>
                      <Button variant='danger' type="submit">Find A Table</Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </motion.section>
    </>
  )
}
